/* eslint-disable eqeqeq */
import React, { MouseEvent } from 'react';
import { useSelector, RootStateOrAny, useDispatch } from 'react-redux';
import {
    updateField,
    setSelected,
    removeFromHand,
    makeAvailable,
    emptyAvailable,
    flipPlayers,
    setCombat,
    emptyCombat,
    killedChar,
    setWinner,
    addToHand,
} from '../../actions';
import { toastr } from 'react-redux-toastr';
import { toastrOptions } from '../../types';

export default function Cell(props: CellProps) {
    const character = useSelector(
        (state: RootStateOrAny) => state.board[props.index[0]][props.index[1]]
    );
    const {
        selected,
        hand,
        board,
        player,
        availableFields,
        combat,
        winner,
    } = useSelector((state: RootStateOrAny) => state);
    const availableFieldsString = availableFields.map((item: any) => {
        return item.toString();
    });

    const dest = props.index;

    const dispatch = useDispatch();
    function cleanup() {
        dispatch(emptyCombat());
        dispatch(setSelected(-1));
        dispatch(emptyAvailable());
    }
    function checkAvailable(x: number, y: number) {
        if (x - 1 >= 0) {
            if (board[x - 1][y].char == 0) dispatch(makeAvailable([x - 1, y]));
        }
        if (x + 1 < 6) {
            if (board[x + 1][y].char == 0) dispatch(makeAvailable([x + 1, y]));
        }
        if (y - 1 >= 0) {
            if (board[x][y - 1].char == 0) dispatch(makeAvailable([x, y - 1]));
        }
        if (y + 1 < 6) {
            if (board[x][y + 1].char == 0) dispatch(makeAvailable([x, y + 1]));
        }
    }

    function handleClick(event: MouseEvent) {
        if (props.prep) {
            //elokeszito szobaban vagyunk
            if (props.available) {
                switch (event.type) {
                    case 'click':
                        //bal eger kattintas -> ha nincs a mezon semmi, van kivalasztott babu
                        //es a mezo elerheto, akkor odahelyezzuk a kivalasztott babut
                        if (selected > -1) {
                            if (character.char == '0') {
                                dispatch(
                                    updateField(
                                        props.index[0],
                                        props.index[1],
                                        hand[selected].toString(),
                                        player
                                    )
                                );
                                dispatch(removeFromHand(selected));
                                dispatch(setSelected(-1));
                            } else {
                                toastr.error(
                                    'A mező foglalt',
                                    'Jobbkattal leveheted a mezőn lévő bábut',
                                    toastrOptions
                                );
                            }
                        } else {
                            toastr.warning(
                                'Nincs kiválasztott bábu',
                                'Válassz ki kattintással egyet a "kezedből"',
                                toastrOptions
                            );
                        }
                        console.log('click');
                        break;
                    case 'contextmenu':
                        //jobb eger -> ha van a mezon babu, visszarakjuk a jatekos kezebe
                        event.preventDefault();
                        if (character.player == player) {
                            dispatch(updateField(props.index[0], props.index[1], '0', 0));
                            dispatch(addToHand(character.char));
                        }

                        break;
                }
            } else {
                toastr.warning(
                    'Ide nem helyezhetsz bábut!',
                    'Csak az alsó 2 sor elérhető',
                    toastrOptions
                );
            }
        } else {
            //jatek uzemmodban vagyunk
            if (winner != 0) {
                return;
            }
            if (character.char != 0) {
                //ha olyan mezore kattintunk ahol van babu
                if (selected.toString() <= '-1') {
                    //ha nincs kivalasztott babu

                    if (character.player == player) {
                        //ha sajat babura kattintunk
                        if (character.char !== 'B' && character.char !== 'F') {
                            dispatch(setSelected(props.index));
                            checkAvailable(props.index[0], props.index[1]);
                        }
                        if (character.char === '2') {
                            //futar, minden mezo elerheto
                            board.forEach((col: string[], colindex: number) => {
                                col.forEach((cell: any, cellindex: number) => {
                                    if (cell.player !== player) {
                                        dispatch(makeAvailable([colindex, cellindex]));
                                    }
                                });
                            });
                        }
                    } else {
                        //ha ellenfel babura kattintunk
                        toastr.warning(
                            'Nem a te bábud',
                            'Csak a saját bábuiddal léphetsz!',
                            toastrOptions
                        );
                    }
                } else if (selected.toString() === props.index.toString()) {
                    //ha a kivalasztottra kattintunk
                    dispatch(setSelected(-1));
                    dispatch(emptyAvailable());
                } else {
                    //ha mas olyanra kattintunk, ahol mar van babu
                    const ourChar = board[selected[0]][selected[1]].char;
                    const enemyChar = character.char;
                    const enemyPlayer = player == 1 ? 2 : 1;
                    if (character.player == player) {
                        //sajat babu
                        toastr.warning(
                            'Saját bábu',
                            'Saját bábuidat nem támadhatod!',
                            toastrOptions
                        );
                    } else {
                        //ellenfel babuja
                        dispatch(setCombat(props.index.toString()));

                        toastr.error(
                            `Csata!!`,
                            `${enemyChar} VS ${ourChar}... izgalmas!`,
                            toastrOptions
                        );
                        setTimeout(() => {
                            if (enemyChar == 'B') {
                                if (ourChar == '3') {
                                    dispatch(
                                        updateField(dest[0], dest[1], ourChar, player)
                                    );
                                    dispatch(
                                        updateField(selected[0], selected[1], '0', 0)
                                    );
                                    dispatch(killedChar(player, enemyChar));
                                } else {
                                    dispatch(
                                        updateField(selected[0], selected[1], '0', 0)
                                    );
                                    dispatch(killedChar(enemyPlayer, ourChar));
                                    //we lose
                                }
                            } else if (enemyChar == 'F') {
                                dispatch(killedChar(player, enemyChar));
                                dispatch(setWinner(player));
                                dispatch(flipPlayers(player));
                            } else if (enemyChar == '10' && ourChar == '1') {
                                dispatch(updateField(dest[0], dest[1], ourChar, player));
                                dispatch(updateField(selected[0], selected[1], '0', 0));
                                dispatch(killedChar(player, enemyChar));
                                //we win
                            } else if (enemyChar == '1' && ourChar == '10') {
                                dispatch(updateField(selected[0], selected[1], '0', 0));
                                dispatch(killedChar(enemyPlayer, ourChar));
                                //we lose
                            } else if (
                                Number.parseInt(ourChar) > Number.parseInt(enemyChar)
                            ) {
                                //we win
                                dispatch(updateField(dest[0], dest[1], ourChar, player));
                                dispatch(updateField(selected[0], selected[1], '0', 0));
                                dispatch(killedChar(player, enemyChar));
                            } else if (
                                Number.parseInt(ourChar) == Number.parseInt(enemyChar)
                            ) {
                                //dontetlen
                                dispatch(updateField(selected[0], selected[1], '0', 0));
                                dispatch(updateField(dest[0], dest[1], '0', 0));
                                dispatch(killedChar(player, enemyChar));
                                dispatch(killedChar(enemyPlayer, ourChar));
                            } else {
                                // we lose
                                dispatch(updateField(selected[0], selected[1], '0', 0));
                                dispatch(killedChar(enemyPlayer, ourChar));
                            }

                            cleanup();
                            dispatch(flipPlayers(player));
                        }, 3000);
                    }
                }
            } else {
                //ha olyan mezore kattintunk ahol nincs babu
                if (selected.toString() > '-1') {
                    //ha van kivalasztott babu
                    const selectedChar = board[selected[0]][selected[1]].char;
                    if (
                        (selectedChar != '2' &&
                            availableFieldsString.includes(props.index.toString())) ||
                        selectedChar == 2
                    ) {
                        //lepes, kijeloles megszuntetese, jatekos csere
                        dispatch(updateField(dest[0], dest[1], selectedChar, player));
                        dispatch(updateField(selected[0], selected[1], '0', 0));
                        dispatch(emptyAvailable());
                        dispatch(setSelected(-1));
                        dispatch(flipPlayers(player));
                    }
                } else {
                    //ha nincs kivalasztott babu
                    toastr.info('Üres mező', 'Hiába kattintasz ide 🤷‍♂️', toastrOptions);
                }
            }
        }
    }

    return (
        <td
            className={
                props.available || availableFieldsString.includes(props.index.toString())
                    ? 'available'
                    : ''
            }
            onClick={handleClick}
            onContextMenu={handleClick}
        >
            {props.hidden ? (
                <img src={require(`../../assets/characters/kerdojel.png`)} alt='' />
            ) : character.char != '0' ? (
                character.player == player || combat == props.index.toString() ? (
                    <img
                        className={
                            props.index.toString() == selected.toString()
                                ? 'selected'
                                : ''
                        }
                        src={require(`../../assets/characters/${character.char}.jpg`)}
                        alt=''
                    />
                ) : (
                    <img src={require(`../../assets/characters/kerdojel.png`)} alt='' />
                )
            ) : (
                // props.index
                ''
            )}
        </td>
    );
}

type CellProps = {
    name?: string;
    available?: Boolean;
    index?: number[] | any;
    prep?: Boolean;
    hidden?: boolean;
};
